import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function CookiePolicy() {
  return (
    <PolicyPage title="Cookie Policy">
      <p>This policy explains how camartzuno uses cookies, browser storage, pixels, tags, and similar technologies on this website.</p>

      <h2>What these technologies do</h2>
      <p>Cookies are small text files saved on your device. Local storage keeps information in your browser. Pixels and tags can register that a page or email was viewed. Some technologies last only for a browsing session; others remain until they expire or you delete them.</p>

      <h2>Categories we may use</h2>
      <ul>
        <li><strong>Strictly necessary:</strong> operate navigation, carts, checkout, security, load balancing, fraud controls, and privacy preferences.</li>
        <li><strong>Functional:</strong> remember selections such as region, language, recently viewed items, or display preferences.</li>
        <li><strong>Analytics and performance:</strong> help measure traffic, errors, page speed, and how visitors use the store.</li>
        <li><strong>Advertising:</strong> where enabled and legally permitted, measure campaigns, limit repetition, and help present more relevant promotions.</li>
      </ul>

      <h2>First- and third-party technologies</h2>
      <p>First-party technologies are set by camartzuno. Third-party technologies may be set by providers supporting payments, security, content delivery, analytics, or advertising. Those providers may process information under their own notices.</p>

      <h2>Your choices</h2>
      <p>You can block or delete cookies through your browser. Where the site presents a consent control, use it to change optional-cookie choices. Blocking strictly necessary storage may prevent the cart, checkout, or security features from working. Browser-based "Do Not Track" signals are not uniformly recognized; where required, we honor legally recognized opt-out preference signals.</p>

      <h2>Retention and updates</h2>
      <p>Cookie duration depends on its purpose and provider. Session cookies normally expire when the browser closes; persistent cookies remain for their stated duration unless deleted sooner. The technologies used may change as the site and providers change, and this policy will be updated accordingly.</p>

      <h2>Contact</h2>
      <p>Questions or privacy requests may be sent to <ContactEmail />.</p>
    </PolicyPage>
  );
}
export default CookiePolicy;
